// Right-click context menu for /team-and-agents (+ /agents, which extends it)
// person + agent nodes. Opens the shared house ContextDropdown — the SAME
// component /files and the project canvas use, mounted globally in
// workspace/app.js. Registered in canvas/functions/index.js; the nodes call
// `tagNodeContextmenu` via el.call from their onContextmenu.
//
// Self-contained on purpose: the build-critical exports live here, NOT in the
// (large, frequently-edited) team-and-agents.js page, so a concurrent edit to
// the page can't break the functions re-export. The node click already opens
// the profile/agent editor; this menu adds the secondary actions.
// (2026-06-19 per Nika "add context menu on humans and agents".)

const _canvasRoot = (el) => el?.state?.root || el?.getRoot?.()?.state?.root || null

// onContextmenu handler bound on each node (`this` = the node element). Seeds
// root.contextDropdown with the node's kind + identity; the global
// ContextDropdown renders the rows (tagNodeContextItems) and dispatches the
// pick (tagNodeContextAction).
export const tagNodeContextmenu = function (e, s, kind) {
  const root = _canvasRoot(this)
  if (!root) return
  e.preventDefault()
  if (e.stopPropagation) e.stopPropagation()
  const id = this?.node?.dataset?.nodeId || (s && (s._nodeId || s.id)) || null
  root.update(
    {
      contextDropdown: {
        open: true,
        x: e.clientX,
        y: e.clientY,
        kind,
        nodeId: id,
        email: (s && (s.email || s.handle)) || null,
        name: (s && (s.name || s.title)) || null,
        itemsFn: 'tagNodeContextItems',
        actionFn: 'tagNodeContextAction'
      }
    },
    { preventFetch: true }
  )
}

// Rows for the right-clicked node — same `{ key, action, label, danger? }` shape
// filesContextItems / projectCanvasContextItems use.
export const tagNodeContextItems = function (root) {
  const cm = root && root.contextDropdown
  if (!cm || !cm.open) return []
  // Resolved here, not at the render site — see canvasContextMenu.js for why.
  const connect = {
    key: 'connect',
    action: 'connect',
    label: this.call('polyglot', 'canvas.team.contextMenu.connect')
  }
  const copy = {
    key: 'copyEmail',
    action: 'copyEmail',
    label: this.call('polyglot', 'canvas.team.contextMenu.copyEmail')
  }
  if (cm.kind === 'agent') {
    // Agents open on click (the node's _onNodeClick opens the agent editor),
    // so the menu carries the secondary actions.
    return [connect, copy]
  }
  return [
    {
      key: 'open',
      action: 'open',
      label: this.call('polyglot', 'canvas.team.contextMenu.openProfile')
    },
    connect,
    copy
  ]
}

// Dispatch a chosen row (`this` = the ContextDropdownItem). Close first, then run.
export const tagNodeContextAction = function (action) {
  const root = _canvasRoot(this)
  if (!root) return
  const cm = root.contextDropdown || {}
  const { nodeId, email } = cm
  root.update({ contextDropdown: null }, { preventFetch: true })
  if (action === 'open') {
    // Person profile modal — the same surface avatar chips / OnlineMembers open.
    if (email) this.call('openProfileModal', email)
  } else if (action === 'connect') {
    // Start a connection from this node — mirrors the node's connect-mode click.
    if (nodeId) root.update({ _tagConnectMode: true, _tagConnectFrom: nodeId })
  } else if (action === 'copyEmail') {
    if (email && typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(email).catch((err) => console.warn('[tag-ctx] copy', err))
    }
  }
}
